import { FormattedMessage } from 'react-intl';
import { Radio } from '@atlaskit/radio';
import { messages } from '../messages';
import React from 'react';
import { styled } from 'styled-components';
import { RecipientType } from '../duck/models';
import { StyledTextfield } from './styledComponents';

const RadioWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 5px;
`;
const EmailRadioWrapper = styled.div`
  display: flex;
`;
const TextfieldWrapper = styled.div`
  min-width: 200px;
`;

const CustomersMap = {
  license: messages.licenseCustomerOption,
  kitty_post_15: messages.allTechnicalContactsCustomerOption,
  kitty_post_212: messages.allContactsCustomerOption,
};

const RecipientsMap = {
  atlassian_invoice: messages.billingContactOrInvoiceRecipient,
  'kitty-partner': messages.partnerContactsRecipient,
  'kitty-partner-customer-notification': messages.allContactsRecipient,
  reviewRequired: messages.reviewRequiredRecipient,
};

const Recipients = ({
  config,
  changeMapOfTypes,
  radioChangeHandle,
  emailChangeHandle,
  changeMapOfEmails,
}) => {
  if (!config) return null;
  const recipient = RecipientsMap[config.templateName];
  const customerRadio = CustomersMap[config.templateName];
  const { recipientType } = config;

  const isRadioChecked = (type: RecipientType) => {
    const checkedByCustomerOption = changeMapOfTypes[config.templateName];
    return checkedByCustomerOption ? checkedByCustomerOption === type : recipientType === type;
  };

  if (!config.configurable) {
    return recipient ? <FormattedMessage {...recipient} /> : null;
  }

  return (
    <RadioWrapper>
      <Radio
        label={customerRadio ? <FormattedMessage {...customerRadio} /> : config.templateName}
        isChecked={isRadioChecked(RecipientType.CUSTOMER)}
        value={RecipientType.CUSTOMER}
        name={config.templateName}
        onChange={radioChangeHandle}
      />
      <Radio
        label={<FormattedMessage {...messages.customerCCPartnerContactsOption} />}
        isChecked={isRadioChecked(RecipientType.CUSTOMER_CC_PARTNER)}
        value={RecipientType.CUSTOMER_CC_PARTNER}
        name={config.templateName}
        onChange={radioChangeHandle}
      />
      <Radio
        label={<FormattedMessage {...messages.customerBCCPartnerContactsOption} />}
        isChecked={isRadioChecked(RecipientType.CUSTOMER_BCC_PARTNER)}
        value={RecipientType.CUSTOMER_BCC_PARTNER}
        name={config.templateName}
        onChange={radioChangeHandle}
      />
      <Radio
        label={<FormattedMessage {...messages.partnerOnlyOption} />}
        isChecked={isRadioChecked(RecipientType.PARTNER)}
        value={RecipientType.PARTNER}
        name={config.templateName}
        onChange={radioChangeHandle}
      />
      <EmailRadioWrapper>
        <Radio
          label={<FormattedMessage {...messages.thisEmail} />}
          isChecked={isRadioChecked(RecipientType.OTHER)}
          value={RecipientType.OTHER}
          name={config.templateName}
          onChange={radioChangeHandle}
        />

        <TextfieldWrapper>
          <StyledTextfield
            $height={2.5}
            defaultValue={config.recipientEmail}
            value={changeMapOfEmails[config.templateName]}
            name={config.templateName}
            onChange={emailChangeHandle}
          />
        </TextfieldWrapper>
      </EmailRadioWrapper>
    </RadioWrapper>
  );
};

export default Recipients;
